export default "__VITE_ASSET__uOfQXf4C__"